































































import RiftSocket, { riftHost, RiftSocketState } from "./rift-socket";
import CodeEntry from "./code-entry.vue";
import { isCompleteCode, normalizeCode } from "./code";
import { Component, Prop, Vue } from "vue-property-decorator";

let didFirstMount = false;

@Component({
    components: { CodeEntry }
})
export default class SocketState extends Vue {
    @Prop()
    socket: RiftSocket;
    code = localStorage ? localStorage.getItem("conduitID") || "" : "";

    mounted() {
        // On our first mount, check if we have a code from the query string. If we do,
        // automatically enter it and try to connect. Only do it on the first mount so if
        // the connection attempt fails, we don't end up automatically connecting again.
        if (!didFirstMount) {
            didFirstMount = true;

            const fromUrl = new URLSearchParams(location.search).get("code");
            if (!fromUrl) return;

            // Clear the code from the URL in case the user ends up adding it to the homescreen.
            // The code gets saved anyway and this saves us the inconvenience of the user linking it to
            // their homescreen and then getting their code changed.
            window.history.replaceState("", "", window.location.pathname);

            this.code = normalizeCode(fromUrl);
            this.connect();
        }
    }

    isCompleteCode(code: string) {
        return isCompleteCode(code);
    }

    connect() {
        if (localStorage) localStorage.setItem("conduitID", this.code);
        this.$emit("connect", this.code);
    }

    get riftHost() {
        return riftHost();
    }

    get didFailPubkey() {
        return this.socket && this.socket.state === RiftSocketState.FAILED_NO_DESKTOP;
    }

    get didGetDenied() {
        return this.socket && this.socket.state === RiftSocketState.FAILED_DESKTOP_DENY;
    }

    get isConnecting() {
        return this.socket && this.socket.state === RiftSocketState.CONNECTING;
    }

    get isHandshaking() {
        return this.socket && this.socket.state === RiftSocketState.HANDSHAKING;
    }
}
